var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "email-container" }, [
    _c(
      "div",
      { staticClass: "email-content" },
      [
        !_vm.isImageAttachActive && !_vm.isDocAttachActive
          ? _c("vue-email", {
              ref: "emailer",
              attrs: {
                value: _vm.emailer,
                "asset-id": _vm.assetId,
                "quote-image-attachments": _vm.selectedImages,
                "quote-attachments": _vm.selectedDocuments,
                "reply-to-message-id": _vm.replyToMessageId,
                "to-emails": _vm.replyToSenderEmails,
                "cc-emails": _vm.replyToEmailCcs,
                "bcc-emails": _vm.replyToEmailBccs,
                subject: _vm.emailSubject,
                message: _vm.emailMessage,
                "is-show-cc-bcc":
                  !!_vm.replyToEmailCcs.length || !!_vm.replyToEmailBccs.length,
              },
              on: {
                "new-email": _vm.newEmailInput,
                "attachments-updated": _vm.handleAttachmentsUpdate,
                "validation-changed": _vm.handleValidationChanged,
                input: function ($event) {
                  return _vm.$emit("update:emailer", $event)
                },
                sent: _vm.sent,
              },
            })
          : _vm._e(),
        _c(
          "base-modal-ex",
          {
            attrs: {
              active: _vm.isImageAttachActive,
              "has-modal-card": true,
              "animation-in": "fadeIn",
              "animation-out": "fadeOut",
              "min-width": 60,
            },
            on: { close: _vm.closeImageModal },
          },
          [
            _c("div", { staticClass: "modal-card" }, [
              _c("header", { staticClass: "modal-card-head" }, [
                _c("p", { staticClass: "modal-card-title" }, [
                  _vm._v("Select Images"),
                ]),
              ]),
              _c(
                "section",
                { staticClass: "modal-card-body" },
                [
                  _c("image-select", {
                    attrs: {
                      "quote-id": _vm.assetId,
                      "quote-ids": _vm.computeQuoteIds,
                      subtitle: `Select images to attach`,
                    },
                    on: { input: _vm.onImagesSelected },
                    model: {
                      value: _vm.selectedImages,
                      callback: function ($$v) {
                        _vm.selectedImages = $$v
                      },
                      expression: "selectedImages",
                    },
                  }),
                ],
                1
              ),
              _c(
                "footer",
                { staticClass: "modal-card-foot is-justify-content-flex-end" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      on: { click: _vm.closeImageModal },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button is-success",
                      on: { click: _vm.confirmImageSelection },
                    },
                    [_vm._v(" Done ")]
                  ),
                ]
              ),
            ]),
          ]
        ),
        _c(
          "base-modal-ex",
          {
            attrs: {
              active: _vm.isDocAttachActive,
              "has-modal-card": true,
              "min-width": 60,
              "animation-in": "fadeIn",
              "animation-out": "fadeOut",
            },
            on: { close: _vm.closeDocModal },
          },
          [
            _c("div", { staticClass: "modal-card" }, [
              _c("header", { staticClass: "modal-card-head" }, [
                _c("p", { staticClass: "modal-card-title" }, [
                  _vm._v("Select Documents"),
                ]),
              ]),
              _c(
                "section",
                { staticClass: "modal-card-body" },
                [
                  _c("attachment-select", {
                    attrs: {
                      "quote-id": _vm.assetId,
                      subtitle: `Select documents to attach`,
                    },
                    on: { input: _vm.onDocumentsSelected },
                    model: {
                      value: _vm.selectedDocuments,
                      callback: function ($$v) {
                        _vm.selectedDocuments = $$v
                      },
                      expression: "selectedDocuments",
                    },
                  }),
                ],
                1
              ),
              _c(
                "footer",
                { staticClass: "modal-card-foot is-justify-content-flex-end" },
                [
                  _c(
                    "button",
                    { staticClass: "button", on: { click: _vm.closeDocModal } },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button is-success",
                      on: { click: _vm.confirmDocSelection },
                    },
                    [_vm._v(" Done ")]
                  ),
                ]
              ),
            ]),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "email-actions" },
      [
        _vm._t("template-actions"),
        _c("div", { staticClass: "buttons" }, [
          _c(
            "button",
            {
              staticClass: "button is-warning tooltip is-tooltip-topright",
              attrs: {
                disabled:
                  !_vm.enableSend ||
                  _vm.isImageAttachActive ||
                  _vm.isDocAttachActive,
                "data-tooltip": "Reset Email",
              },
              on: { click: _vm.resetEmail },
            },
            [_vm._m(0), _c("span", [_vm._v("Reset")])]
          ),
          _vm.enableAttach
            ? _c(
                "div",
                {
                  staticClass: "dropdown",
                  class: { "is-active": _vm.showAttachDropdown },
                  staticStyle: { display: "inline-block" },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      on: { click: _vm.toggleAttachDropdown },
                    },
                    [_vm._m(1)]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu",
                      staticStyle: {
                        left: "-120px",
                        right: "auto",
                        top: "auto",
                        bottom: "100%",
                        transform: "translateY(-8px)",
                      },
                      attrs: { role: "menu" },
                    },
                    [
                      _c("div", {
                        staticStyle: {
                          position: "absolute",
                          left: "130px",
                          bottom: "-8px",
                          width: "0",
                          height: "0",
                          "border-left": "8px solid transparent",
                          "border-right": "8px solid transparent",
                          "border-top": "8px solid #fff",
                          "z-index": "2",
                        },
                      }),
                      _c("div", { staticClass: "dropdown-content" }, [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.showAttachImage },
                          },
                          [_vm._m(2), _vm._v(" Images ")]
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.attachDocs },
                          },
                          [_vm._m(3), _vm._v(" Documents ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "button is-success",
              attrs: {
                disabled:
                  !_vm.enableSend ||
                  _vm.isImageAttachActive ||
                  _vm.isDocAttachActive,
              },
              on: { click: _vm.sendEmail },
            },
            [_vm._m(4), _c("span", [_vm._v("Send")])]
          ),
        ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-refresh mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-paperclip" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-image-multiple" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-file-document-outline" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-send" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }